import http from "../../../../services/http";
import {
  IAPI_COM011_Request,
  IAPI_COM011_Response,
  IAPI_COM012_Request,
  IAPI_COM012_Response,
} from "../../../../type/apiType";

import { ApiUrl } from "../../../../assets/data/TkApiUrlProperty";

const httpGetBankList = async (
  param: IAPI_COM011_Request
): Promise<IAPI_COM011_Response> => {
  let res = await http.post(ApiUrl.API_COM011, {
    ...param,
  });
  return res.data;
};

const httpGetBranch = async (
  param: IAPI_COM012_Request
): Promise<IAPI_COM012_Response> => {
  let res = await http.post(ApiUrl.API_COM012, {
    ...param,
  });
  return res.data;
};

export { httpGetBankList, httpGetBranch };
